<template>

  <!-- <v-container fluid fill-height> -->
    <!-- <v-layout text-xs-center wrap>
      <v-flex xs12 sm6 offset-sm3>
        <v-card color="orange darken-3" text-center elevation="0">
          <v-img src="https://www.avcl.co.nz/COMP702ENEL791BrewBuddy/App/AppTest2/src/assets/logowhite.png" contain height="200"></v-img>
          <v-flex xs3></v-flex>
           <v-flex xs6> 
       <v-btn block @click="gobrew">Brew</v-btn>
         <v-btn block @click="gosetup"><v-icon>home</v-icon>Brewery Setup</v-btn>
           </v-flex>
                <v-flex xs3></v-flex>

   
        
          <v-btn @click="gomanual">Manual Control</v-btn>
          <v-btn @click="gobook">Recipe Book</v-btn>
          <v-btn @click="goclean">Clean</v-btn>
          <v-card-title primary-title>
            <div class="ma-auto">
              <span class="grey--text">IDF version: {{version}}</span>
              <br>
              <span class="grey--text">ESP cores: {{cores}}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout> -->
     <!-- <v-main fluid fill-height class="grey lighten-3">  -->
       <!-- <v-container fluid fill-height xs12 md8 sm6> -->

     
           <!-- <v-flex xs12 sm6 fill-height> -->
  <v-row class="fill-height justify-center" justify-center :justify="center" > 
    <v-col cols="12" sm="8"  md="6" lg="4" class="justify-center" justify-center :justify="center" >
      <v-card class="fill-height justify-center text-center" color="orange darken-3" elevation="0">  
        <v-row> 
          <v-col class="px-6">
            <v-img src="https://www.avcl.co.nz/COMP702ENEL791BrewBuddy/App/AppTest2/src/assets/logowhite.png" contain height="200"></v-img>
          </v-col>
        </v-row>
        <!-- <v-row ><v-col><v-btn block  @click="gobrew">Brew</v-btn></v-col></v-row>
        <v-row ><v-col><v-spacer><v-btn block @click="gosetup"><v-icon>settings</v-icon>Brewery Setup</v-btn></v-spacer></v-col></v-row>
        <v-row><v-col v-for="n in 3" :key="n" :cols="n === 2 ? 8 : 2"><v-btn v-if="n===2" block  @click="gomanual">Manual Control</v-btn></v-col></v-row>
        <v-row class="px-12"><v-col><v-btn block text @click="gobook">Recipe Book</v-btn></v-col></v-row>
        <v-row class="px-12"><v-col><v-btn block @click="goclean">Clean</v-btn></v-col></v-row> -->
        <v-row><v-col v-for="n in 3" :key="n" :cols="n === 2 ? 8 : 2"><v-btn v-if="n===2" block @click="gobrew">Brew</v-btn></v-col></v-row>
        <v-row><v-col v-for="n in 3" :key="n" :cols="n === 2 ? 8 : 2"><v-btn v-if="n===2" block @click="gosetup"><v-icon>settings</v-icon>Brewery Setup</v-btn></v-col></v-row>
        <v-row><v-col v-for="n in 3" :key="n" :cols="n === 2 ? 8 : 2"><v-btn v-if="n===2" block @click="gomanual">Manual Control</v-btn></v-col></v-row>
        <v-row><v-col v-for="n in 3" :key="n" :cols="n === 2 ? 8 : 2"><v-btn v-if="n===2" block @click="gobook">Recipe Book</v-btn></v-col></v-row>
        <v-row><v-col v-for="n in 3" :key="n" :cols="n === 2 ? 8 : 2"><v-btn v-if="n===2" block @click="goclean">Clean</v-btn></v-col></v-row>
      </v-card> 
    </v-col>
  </v-row>
</template>

<script>
export default {
  data () {
    return {
      version: null,
      cores: null
    }
  },
  mounted () {
    this.$ajax
      .get('api/v1/system/info')
      .then(data => {
        this.version = data.data.version
        this.cores = data.data.cores
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    gomanual () {
      this.$router.push('/manual')
    },
    gosetup () {
      this.$router.push('/setup')
    },
    gobrew () {
      this.$router.push('brew')
    },
    gobook () {
      this.$router.push('/book')
    },
    goclean () {
      this.$router.push('/clean')
    }
  }
}
</script>
